var map = {
	"./About.vue": [
		711,
		711
	],
	"./Datenschutz.vue": [
		8027,
		27
	],
	"./Home.vue": [
		6076,
		76
	],
	"./Impressum.vue": [
		9678,
		678
	],
	"./Infothek.vue": [
		3785,
		785
	],
	"./Infothek_old.vue": [
		7511,
		511
	],
	"./Kontakt.vue": [
		9442,
		442
	],
	"./Lerneinheiten.vue": [
		3082,
		82
	],
	"./Material.vue": [
		6717,
		770
	],
	"./MemoryDetail.vue": [
		3840,
		840
	],
	"./MemoryOverview.vue": [
		9531,
		531
	],
	"./MethodDetail.vue": [
		8418,
		418
	],
	"./MethodPdfDownload.vue": [
		3124,
		124
	],
	"./MethodSubmit.vue": [
		8591,
		591
	],
	"./Methods.vue": [
		2644,
		644
	],
	"./News.vue": [
		7954,
		954
	],
	"./NewsDetail.vue": [
		8355,
		355
	],
	"./Page.vue": [
		1127,
		127
	],
	"./PugTest.vue": [
		9429,
		429
	],
	"./ShoppingCart.vue": [
		5041,
		41
	],
	"./Team.vue": [
		7067,
		866
	],
	"./WorkshopDetail.vue": [
		3993,
		993
	],
	"./WorkshopOverview.vue": [
		5574,
		574
	],
	"./WorkshopRequest.vue": [
		4733,
		733
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2513;
module.exports = webpackAsyncContext;